import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
    :root {
        ${(props) =>
          props.theme.breakpoints
            .map((bp: number, index: number) => {
              if (index === 0) return `font-size: ${props.theme.rootFontSize};`;

              return `@media (min-width: ${bp}px) {font-size: calc(${props.theme.rootFontSize} + ${index}px);}`;
            })
            .join('\n')}
    }

    body {
        line-height: normal;
        background-image: url(/assets/background-lines.svg);
        background-repeat: no-repeat;
        background-size: 1010px auto;
        background-position: top right;
        transition: none;
    }
`;
